<template>
	<transition name="el-notification-fade">
		<div class="el-notification right" v-if="messageList.length > 0">
			<div class="messageBox" :style="{ height: messageBoxHeight }">
				<div
					v-for="(item, index) in messageList"
					:key="index"
					class="message-item"
					:style="{
						top: index * 30 + 'px',
					}"
					:ref="item.type"
				>
					<div class="el-dialog__header flex-row-center-between border-top-1">
						<p class="yx-color-text-primary font-h4-regular">
							<i class="i-notice"></i>
							<span class="ml-6">{{ item.title }}</span>
						</p>
						<i class="el-icon-close close cursor-pointer" @click="handClose(item.type)"></i>
					</div>
					<div class="el-dialog__body p-24 font-h5-regular" v-html="item.content"></div>
					<div class="el-dialog__footer" v-if="item.jumpUrl">
						<div class="dialog-footer">
							<el-button @click="confirm(item.type, item.jumpUrl, item.isjump)">{{ item.butttonText || '立即查看' }}</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
import { getPlugVersionApi } from '@/api/talentCRM';
import { readMessage } from '@/api/common';
import { tooltipstopReasonTypeMap } from '@/utils/newDataMap/talentObtain';

// 用来区分收录达人的公告线索分配类型
const allotTypeMap = new Map([
	[
		1,
		{
			tips: '可前往”团队公海”认领并及时跟进。',
			path: '/talentCRM/groupSeas?source=4&claim_status=-1',
		},
	], //公海
	[
		2,
		{
			tips: '可前往”我的达人”菜单查看并及时跟进。',
			path: '/talentCRM/myTalent',
		},
	], //轮流
	[
		3,
		{
			tips: '可前往”我的达人”菜单查看并及时跟进。',
			path: '/talentCRM/myTalent',
		},
	], //随机
]);
export default {
	name: 'noticeDialog',
	data() {
		return {
			visibile: false,
			content: '',
			title: '',
			jumpUrl: '',
			version: '',
			messageList: [],
		};
	},
	created() {
		this.getPlugVersion();
		setInterval(() => {
			this.getPlugVersion();
		}, 1000 * 120);
	},
	computed: {
		messageBoxHeight() {
			return this.messageList.length * 30 + 190 + 'px';
		},
	},
	methods: {
		async getPlugVersion() {
			if (document.visibilityState === 'hidden') {
				return;
			}
			const ishave = this.$auth.hasPermi('talentCRM:clueSeas:dyAlliance');
			if (!ishave) return;
			const res = await getPlugVersionApi();
			const { fileManage, allotAnchor, pluginClose } = res;
			if (fileManage.send_message_is) {
				const { is_pop, remark, resource_version } = fileManage;
				this.version = resource_version;
				if (is_pop) {
					const newMessage = {
						type: `cyt_plugin_anchor:${resource_version}`,
						title: '公告',
						content: remark,
						jumpUrl: '/talentCRM/clueSeas?tab=dyAlliance&platform_id=1',
						butttonText: '立即查看',
						isjump: true,
					};
					this.messageList.push(newMessage);
				}
			}
			allotAnchor.forEach(element => {
				if (element.is_pop) {
					const newMessage = {
						type: element.keyType,
						title: '线索达人请及时跟进',
						content: `新获取到${element.anchor}${dataMap.PLATFORM_OBJ[element.platformId].label}达人线索，${
							allotTypeMap.get(element.allotType).tips
						}`,
						jumpUrl: `${allotTypeMap.get(element.allotType).path}${element.allotType === 1 ? '&' : '?'}platform_id=${element.platformId}`,
						butttonText: '立即查看',
						isjump: true,
					};
					if (this.messageList.findIndex(i => i.type === element.keyType) === -1) {
						this.messageList.push(newMessage);
					}
				}
			});
			pluginClose.forEach(element => {
				if (element.is_pop) {
					const newMessage = {
						type: element.keyType,
						title: '插件找达人任务关闭提醒',
						content: `${dataMap.PLATFORM_OBJ[element.platformId].label}平台插件自动找达人任务因"${
							tooltipstopReasonTypeMap[element.stop_reason_type]
						}"导致关闭，请及时处理`,
						jumpUrl: '1',
						butttonText: '我知道了',
						isjump: false,
					};
					if (this.messageList.findIndex(i => i.type === element.keyType) === -1) {
						this.messageList.push(newMessage);
					}
				}
			});
			// 删除重复的公告
		},

		async confirm(type, jumpUrl, isjump = true) {
			if (!isjump) {
				this.handClose(type);
				return;
			}
			let link = '';
			// 绝对地址直接跳转，相对地址解析
			if (jumpUrl.startsWith('http')) {
				link = jumpUrl;
			} else {
				const { href } = this.$router.resolve({
					path: jumpUrl,
				});
				link = href;
			}
			console.log('href', link);
			window.open(link, '_blank');
			this.handClose(type);
		},

		handClose(type) {
			readMessage({
				type,
			});
			this.$refs[type][0].style.right = '-466px';
			this.messageList = this.messageList.filter(item => item.type !== type);
			this.$nextTick(() => {
				this.visibile = false;
			});
		},
	},
};
</script>
<style lang="less" scoped>
::v-deep.el-notification {
	padding: 0;
	z-index: 2999;
}
.follow {
	width: 450px;
	position: relative;
	/deep/ .el-button {
		border: 1px solid @color-primary;
		color: @color-primary;
	}
}
.messageBox {
	width: 100%;
}
.message-item {
	width: 100%;
	position: absolute;
	z-index: 2003;
	background: #fff;
	right: 0;
	transition: right 0.5s;
}
.border-top-1 {
	border-top: 1px solid #eeeeee;
}
</style>
